import './index.scss';
import WebViewer from '@pdftron/webviewer';
import { array, func, object, string } from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
const renderAnnotations = options => {
    const { bookmarks, docViewer, Annotations, annotManager } = options;
    annotManager.disableReadOnlyMode();
    const oldAnnots = annotManager.getAnnotationsList();
    annotManager.deleteAnnotations(oldAnnots);
    const annotations = bookmarks.flatMap(bookmark => bookmark.annotations);
    let first = true;
    annotations.forEach(annotation => {
        const { x1: rgx1, y1: rgy1, x2: rgx2, y2: rgy2 } = annotation.coordinates;
        const { pageNum: pageNumber } = annotation;
        const pageWidth = Math.floor(docViewer.getPageWidth(pageNumber));
        const pageHeight = Math.floor(docViewer.getPageHeight(pageNumber));
        const highlight = new Annotations.TextHighlightAnnotation();
        const x1 = Math.floor(rgx1 * pageWidth);
        const y1 = Math.floor(rgy1 * pageHeight);
        const x2 = Math.floor(rgx2 * pageWidth);
        const y2 = Math.floor(rgy2 * pageHeight);
        highlight.PageNumber = pageNumber;
        highlight.StrokeColor = new Annotations.Color(255, 255, 0);
        highlight.Quads = [
            { x1, y1: y2, x2, y2, x3: x2, y3: y1, x4: x1, y4: y1 },
        ];
        annotManager.addAnnotation(highlight);
        annotManager.drawAnnotations(highlight.PageNumber);
        if (first) {
            first = false;
            annotManager.jumpToAnnotation(highlight);
        }
    });
    annotManager.enableReadOnlyMode();
};
const loadDocument = (document, instance) => {
    instance.loadDocument(document.blob);
};
const PDFViewer = ({ bookmarks, document, setIsDocumentRendered, type, }) => {
    PDFViewer.propTypes = {
        bookmarks: array,
        document: object.isRequired,
        setIsDocumentRendered: func,
        type: string.isRequired,
    };
    const viewer = useRef(null);
    const instance = useRef(null);
    const [documentId, setDocumentId] = useState(document.fileId);
    useEffect(() => {
        WebViewer({
            path: '/webviewer/lib',
            licenseKey: window.RG_CONFIG.APRYSE_LICENSE,
            disabledElements: [
                'contextMenuPopup',
                'copyTextButton',
                'leftPanelButton',
                'menuButton',
                'panToolButton',
                'selectToolButton',
                'toolbarGroup-View',
                'toggleCompareModeButton',
                'toggleNotesButton',
            ],
            disableLogs: !window.RG_CONFIG.DEBUG,
        }, viewer.current).then(inst => {
            if (typeof window.PDFViewer !== 'object')
                window.PDFViewer = {};
            window.PDFViewer[type] = inst;
            const { docViewer, annotManager, Annotations } = inst;
            loadDocument(document, inst);
            docViewer.on('documentLoaded', () => {
                instance.current = inst;
                if (bookmarks) {
                    renderAnnotations({ bookmarks, docViewer, Annotations, annotManager });
                }
                setIsDocumentRendered(true);
                if (document.fileId !== documentId) {
                    setDocumentId(document.fileId);
                    loadDocument(document, inst);
                }
            });
            annotManager.enableReadOnlyMode();
        });
    }, []);
    useEffect(() => {
        if (instance.current) {
            if (typeof window.PDFViewer !== 'object')
                window.PDFViewer = {};
            window.PDFViewer[type] = instance.current;
            const { docViewer, annotManager, Annotations } = instance.current;
            const annots = annotManager.getAnnotationsList();
            annotManager.deleteAnnotations(annots);
            if (bookmarks) {
                try {
                    renderAnnotations({ bookmarks, docViewer, Annotations, annotManager });
                }
                catch (err) {
                    console.error('Failed to render annotations');
                }
            }
            if (document.fileId !== documentId) {
                setDocumentId(document.fileId);
                loadDocument(document, instance.current);
            }
        }
    }, [bookmarks, documentId, document, type]);
    return (React.createElement("div", { className: 'old-webviewer', ref: viewer }));
};
export default PDFViewer;
